import React, { useContext } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import { ModalContext } from 'ui-blocks/filter-table/withFilterTableModal';

const withModal = (title, Component) => {
   const WrappedComponent = (props) => {
      const { isOpen, setIsOpen, modalState } = useContext(ModalContext);

      const closeModal = () => {
         setIsOpen(false);
      };

      return (
         <Modal
            size={modalState.modalSize || 'md'}
            isOpen={isOpen}
            toggle={closeModal}
         >
            <ModalHeader
               toggle={closeModal}
            >
               { modalState.modalTitle ? modalState.modalTitle : title }
            </ModalHeader>
            <ModalBody>
               <Component
                  closeModalCb={closeModal}
                  modalState={modalState}
                  { ...props }
               />
            </ModalBody>
         </Modal>
      );
   };
   return WrappedComponent;
};

export default withModal;
